import React from 'react';

import { DiffEditor } from '@monaco-editor/react';

function MonacoDiffEditor({ original, modified }: { original: string; modified: string }) {
	return <DiffEditor height='70vh' width={'100%'} language='plaintext' original={original} modified={modified} />;
}

export default MonacoDiffEditor;
